import ActionTypes from './actionTypes';
/*
Yet to be implemented, code will likely be moved to relevant file upon implementation
*/
export function getBillingAction(contractIdentifier) {
  return {
    type: ActionTypes.BILLING.REQUEST,
    contractIdentifier: contractIdentifier
  };
}

export function getBillingReset() {
  return {
    type: ActionTypes.BILLING.RESET
  };
}

export function getBillingSuccess(response) {
  return {
    type: ActionTypes.BILLING.SUCCESS,
    response: response.paymentReceiverSummaryRecord
    
  };
}

export function getBillingFailure() {
  return {
    type: ActionTypes.BILLING.FAILURE
  };
}

